import { useCallback } from 'react';
import { edmCampaign } from '@bingads-webui/edm-campaign';

export const useSearchLocationData = (aid, cid) => {
  const getLocation = useCallback(search => edmCampaign.Customers.$withKey(cid).Accounts.$withKey(aid).Locations.get({
    select: ['ParentLocations'],
    search,
  }).toPromise()
    .then(response => response)
    .catch(error => Promise.reject(error)), [aid, cid]);

  return {
    getLocation,
  };
};
